import {
  blocksOptionsConfig,
  newCollectionTemplate,
} from "@components/cmsBlocks/configs";
export const typeSlider = blocksOptionsConfig.collectionTypes.sliderV1.value;

export const sliderConfig = newCollectionTemplate({
  typeFields: {
    link: "text",
    title: "text",
    image: "image",
    alt: "text",
    setId: null,
    setType: "",
    setTitle: "",
    isShow: "boolean",
  },
  fields: {
    link: "",
    title: "",
    image: "",
    alt: "",
    setId: null,
    setType: "",
    setTitle: "",
    isShow: true,
  },
  type: typeSlider,
  showAsTitle: "title", // only texts fields
  allowUseSets: true,
});

// export const sliderConfig1

export const initBlockData = {
  title: "",
  collections: {
    [typeSlider]: {
      ...sliderConfig,
      items: [],
    },
  },
};
export const initEmptyBlockData = {
  title: "",
  collections: {
    [typeSlider]: {
      ...sliderConfig,
      items: [],
    },
  },
};
